import { getVapidKey, subscribePush } from "./api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

export async function enablePush() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    throw new Error("Push nu este suportat pe acest dispozitiv/browser.");
  }
  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    throw new Error("Permisiunea pentru notificări a fost refuzată.");
  }
  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;
  const publicKey = await getVapidKey();
  let sub = await reg.pushManager.getSubscription();
  try {
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey),
      });
    }
  } catch (err) {
    const m = (err && err.message) || "";
    if (/push service error|Registration failed|permission denied/i.test(m)) {
      throw new Error(
        "Browserul blochează notificările push. Dacă folosești Brave: intră în brave://settings/privacy și activează „Use Google services for push messaging”, apoi repornește Brave (sau folosește Google Chrome). Notă: NU e obligatoriu pentru test — alerta și sunetul apar oricum cu aplicația deschisă."
      );
    }
    throw err;
  }
  await subscribePush(sub.toJSON());
  return true;
}

export function pushPermissionState() {
  if (!("Notification" in window)) return "unsupported";
  return Notification.permission;
}
